const DEMO_CLIENT_ID = "9";

export const isDemoUser = () => {
  const clientId = localStorage.getItem("client-id");
  return clientId !== null && clientId.trim() === DEMO_CLIENT_ID;
};

export const isDashboardDemoClient = isDemoUser;
